import React, { useEffect } from 'react';
import { CommonActions } from '@react-navigation/native';
import { getItems } from 'utils/jwtHelpers';
import { useAppDispatch } from 'store/hooks';
import { fetchAppData } from 'actions/refresh';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const PrivateRoute = ({ children, requiresRedirect = true, }) => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    useEffect(() => {
        const checkTokens = async () => {
            const tokens = await getItems(['access_token', 'refresh_token']);
            const accessToken = tokens?.[0]?.[1];
            const refreshToken = tokens?.[1]?.[1];
            if (!accessToken || !refreshToken) {
                const { pathname, search } = window.location;
                // Invite links keep their code for after sign-in. A blocked or full
                // sessionStorage throws, which mustn't stop the redirect below.
                try {
                    if (pathname.startsWith('/join-space/')) {
                        const joinSpaceToken = pathname.replace('/join-space/', '');
                        const params = new URLSearchParams(search);
                        const spaceName = params.get('spaceName') || '';
                        window.sessionStorage.setItem('joinSpaceToken', joinSpaceToken);
                        window.sessionStorage.setItem('joinSpaceName', spaceName);
                    }
                    // Group invites keep their code the same way, for after sign-in
                    if (pathname === '/join-group') {
                        const groupCode = new URLSearchParams(search).get('accessCode');
                        if (groupCode) {
                            window.sessionStorage.setItem('joinGroupCode', groupCode);
                        }
                    }
                }
                catch {
                    // noop
                }
                if (requiresRedirect) {
                    navigation.dispatch(CommonActions.reset({
                        index: 0,
                        routes: [{ name: 'Feed' }],
                    }));
                }
            }
            else {
                const routeIndex = navigation.getState().index;
                if (routeIndex === 0) {
                    dispatch(fetchAppData());
                }
            }
        };
        checkTokens();
    }, [dispatch, navigation, requiresRedirect]);
    return children;
};
const defaultOptions = { requiresRedirect: true };
const withPrivateRoute = (WrappedComponent, options = defaultOptions) => (props) => (<PrivateRoute requiresRedirect={options.requiresRedirect}>
        <WrappedComponent {...props}/>
      </PrivateRoute>);
export default withPrivateRoute;
